<template>
  <div
    class="flex items-center justify-between space-x-4 p-2 text-sm"
  >
    <div class="flex-1">
      <p class="text-lg font-semibold">
        {{ customer.name }}
      </p>
      <p
        v-if="customer.email"
        class="flex items-center text-sm text-background-fg/87"
      >
        <IconHeroiconsEnvelope class="mr-2" />

        {{ customer.email }}
      </p>
      <p
        v-if="customer.phone"
        class="flex items-center text-sm text-background-fg/87"
      >
        <IconHeroiconsPhone class="mr-2" />
        {{ customer.phone }}
      </p>
    </div>

    <div class="w-24 shrink-0 text-right">
      <p class="text-lg text-background-fg/70"> Total </p>
      <p class="text-2xl font-bold text-primary">
        {{ formatToCurrencyString(customer.totalPayments) }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { RetrieveCustomerResponse } from "@/services/customers/retrieveCustomer"
import type { ListCustomersResponseItem } from "@/services/customers/listCustomers"

defineProps<{
  customer:
    | RetrieveCustomerResponse
    | ListCustomersResponseItem
}>()
</script>
